export const apiEnv = {
  LAST_PATH: {
    LIGHTHOUSE: 'lighthouse',
    LIGHTHOUSE_AUTH: 'lighthouseAuth',
    CONFIG_SYSTEM: 'configurazioneSistema',
    CERTIFICATION: 'lightHouse/certificazione',
  },
  APIS: {
    GET_ALL_MODEL_CAR: 'getAllModelCar',
    GET_ALL_COLOR_EXT_CAR: 'getAllLastKnowExternalColor',
    GET_ALL_COLOR_INT_CAR: 'getAllLastKnowInternalColor',
    GET_ALL_CERTIFICATION_LIGHT_HOUSE: 'getAllCertificationLightHouse',
    GET_VEHICLE_CARD_INFORMATION: 'getVehicleCardInformation',
    NEGOTIABILITY: 'negotiability',
    GET_CERTIFICATION_DETAILS: 'getCertificationDetails',
    DO_LOGIN: 'getCertificationDetails',
  },
  env:
    window.location.hostname.match(/.*test.*/)
    || window.location.hostname.match(/.*tst.*/)
    || window.location.hostname.match(/.*localhost.*/)
      ? 'dev'
      : 'prod',
  dev: {
    url: (lastPath, api) => `https://apis-test.ferrari.com/classiche-proxy-sit/v1/api/${lastPath}/${api}`,
    urlAccessToken: () => 'https://iam.dev.ferrari.com/devferrarib2ctenant.onmicrosoft.com/b2c_1a_signup_signin_myf/oauth2/v2.0/token',
    urlConvertToken: () => 'https://iam.dev.ferrari.com/devferrarib2ctenant.onmicrosoft.com/b2c_1a_signup_signin_myf/discovery/v2.0/keys',
    loginUrl: (policy) => `https://iam.dev.ferrari.com/devferrarib2ctenant.onmicrosoft.com/${policy}/oauth2/v2.0/authorize`,
    client_id: '3a1e863a-1445-4a85-aa8c-19fde3c9bc6a',
    client_id_login: 'c268f32c-b1e4-4663-8ae5-fed7fbb44dfa',
    client_id_mcs: 'ceda7d5ef6bb4d938889cea5cfbec425',
    client_id_name: 'lighthouse',
    policy: 'b2c_1a_signup_signin_myf',
    code_challenge_method: 'S256',
    grant_type_request_access_token: 'authorization_code',
    grant_type_refresh_access_token: 'refresh_token',
    grant_type_convert_access_token:
      'urn:ietf:params:oauth:grant-type:jwt-bearer',
    scope: 'openid offline_access',
    response_type: 'code',
    prompt: 'login',
    redirect_uri: (pathname) => `https://registro-tst.ferrari.com${pathname}`,
    // state: 'ANgMpVS8kemaRXyOh2pn',
    nonce: 'nsPTrbNoJwo5m72Fh6VQ',
    token:
      'I?1+9M~UP,7fA!l=Ds~5GJw@zZgS%dwef^aEo7',
    mailto: 'FerrariClassiche@Ferrari.com',
    mailtoOwnership: 'CustomerService@owners.Ferrari.com',
  },
  prod: {
    url: (lastPath, api) => `https://apis.ferrari.com/classiche-proxy/v1/api/${lastPath}/${api}`,
    urlAccessToken: () => 'https://iam.ferrari.com/ferrarib2ctenant.onmicrosoft.com/b2c_1a_signup_signin_myf/oauth2/v2.0/token',
    urlConvertToken: () => 'https://iam.ferrari.com/ferrarib2ctenant.onmicrosoft.com/b2c_1a_signup_signin_myf/discovery/v2.0/keys',
    loginUrl: (policy) => `https://iam.ferrari.com/ferrarib2ctenant.onmicrosoft.com/${policy}/oauth2/v2.0/authorize`,
    client_id: '3a1e863a-1445-4a85-aa8c-19fde3c9bc6a',
    client_id_login: 'a8521c69-7db3-4d52-a7fb-a7bd156023dc',
    client_id_mcs: 'ceda7d5ef6bb4d938889cea5cfbec425',
    client_id_name: 'lighthouse',
    policy: 'b2c_1a_signup_signin_myf',
    code_challenge_method: 'S256',
    grant_type_request_access_token: 'authorization_code',
    grant_type_refresh_access_token: 'refresh_token',
    grant_type_convert_access_token:
      'urn:ietf:params:oauth:grant-type:jwt-bearer',
    scope: 'openid offline_access',
    response_type: 'code',
    prompt: 'login',
    redirect_uri: (pathname) => `https://registro.ferrari.com${pathname}`,
    // state: 'ANgMpVS8kemaRXyOh2pn',
    nonce: 'nsPTrbNoJwo5m72Fh6VQ',
    token:
      'I?1+9M~UP,7fA!l=Ds~5GJw@zZgS%dwef^aEo7',
    mailto: 'FerrariClassiche@Ferrari.com',
    mailtoOwnership: 'CustomerService@owners.Ferrari.com',
  },
};

const headersForJson = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  //'oracle-mobile-backend-id': apiEnv[apiEnv.env].client_id,
  //'X-Very-Temporary-Auth-Key': `${apiEnv[apiEnv.env].token}`,
};

const headersForPlainText = {
  Accept: '*/*',
  'Content-Type': 'application/x-www-form-urlencoded',
};

const headersForm = {
  Accept: '*/*',
  //'X-Very-Temporary-Auth-Key': `${apiEnv[apiEnv.env].token}`,
};

const headersWithAuthentication = (token) => ({
  ...headersForJson,
  Authorization: `Bearer ${token}`,
});

const headersWithAuthenticationForm = (token) => ({
  ...headersForm,
  Authorization: `Bearer ${token}`,
});

function client(method, url, token, data, customHeaders, noParse) {
  const headers = customHeaders
    || (token ? headersWithAuthentication(token) : headersForJson);
  const params = { headers, method };

  if (typeof data !== 'undefined') {
    params.body = !noParse ? JSON.stringify(data) : data;
  }
  return fetch(url, params).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw Error(response.statusText);
  });
}

function clientFormData(method, url, token, data) {
  const headers = token ? headersWithAuthenticationForm(token) : headersForm;
  const params = { headers, method };
  const formData = new FormData();
  Object.keys(data).forEach((key) => {
    formData.append(key, data[key]);
  });
  if (typeof data !== 'undefined') {
    params.body = formData;
  }

  return fetch(url, params).then((response) => {
    if (response.ok) {
      return response.json();
    }
    throw Error(response.statusText);
  });
}

function del(token) {
  return (endpoint, body) => {
    const url = new URL(endpoint);

    return client('DELETE', url, token, body);
  };
}

function get(token) {
  return (endpoint, searchParams) => {
    const url = new URL(endpoint);
    if (typeof searchParams !== 'undefined') {
      Object.keys(searchParams).forEach((key) => {
        url.searchParams.append(key, searchParams[key]);
      });
    }

    return client('GET', url.toString(), token);
  };
}

function patch(token) {
  return (endpoint, data) => {
    const url = new URL(endpoint);

    return client('PATCH', url.toString(), token, data);
  };
}

function post(token, textPlain) {
  return (endpoint, data) => {
    const url = new URL(endpoint);
    const headers = textPlain ? { ...headersForPlainText } : null;
    return client('POST', url.toString(), token, data, headers, textPlain);
  };
}

function postWithForm(token) {
  return (endpoint, data) => {
    const url = new URL(endpoint);

    return clientFormData('POST', url.toString(), token, data);
  };
}

function put(token) {
  return (endpoint, data) => {
    const url = new URL(endpoint);

    return client('PUT', url.toString(), token, data);
  };
}

export default {
  del,
  get,
  patch,
  post,
  put,
  postWithForm,
};
